import { render, staticRenderFns } from "./GsInfo.vue?vue&type=template&id=20554026&scoped=true&lang=html"
import script from "./GsInfo.vue?vue&type=script&lang=js"
export * from "./GsInfo.vue?vue&type=script&lang=js"
import style0 from "./GsInfo.vue?vue&type=style&index=0&id=20554026&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20554026",
  null
  
)

export default component.exports